export const unifiedError = {
  // 内容策略相关
  content_policy: '内容不符合平台政策，请修改后重试',
  safety_policy: '内容不符合安全政策，请修改后重试',
  recitation: '内容可能涉及版权问题，请修改提示词后重试',
  
  // 资源限制相关
  rate_limit: '请求过于频繁，请稍后再试',
  credits: '积分不足，请订阅套餐或购买积分包',
  quota_exceeded: '已达到使用配额限制，请稍后再试',
  
  // 生成相关
  no_image: '无法为此提示词生成图片，请尝试修改提示词',
  generation_failed: '生成失败，请重试',
  timeout: '处理超时，请稍后查看历史记录',
  
  // 网络和服务器相关
  network_error: '网络连接失败，请检查网络后重试',
  server_error: '服务器内部错误，请稍后重试',
  auth_error: '身份验证失败，请重新登录',
  not_found: '请求的资源未找到',
  
  // 输入验证相关
  invalid_input: '输入内容无效，请检查后重试',
  missing_required: '请填写必填项',
  
  // 未知错误
  unknown: '发生未知错误，请重试',
  
  // 通用消息
  general: {
    operationFailed: '操作失败，请重试',
    tryAgainLater: '请稍后再试',
    contactSupport: '如果问题持续存在，请联系客服'
  }
};